import windy from "/assets/windy.png";
const WaterLevel = ({ waterLevel, currentWaterLevel }) => {
  return (
    <div className="water-level">
    

      <div className="average-level">
      <img src={windy} alt="windy" className="title" />
        <label>ระดับน้ำเฉลี่ย</label>
        <strong>{waterLevel} ม.รทก.</strong>
        <label>ระดับน้ำเพิ่ม/ลด</label>
        <strong>{currentWaterLevel} ม.รทก.</strong>
      </div>
    </div>
  );
};

export default WaterLevel;
